import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogRef } from '@angular/material/dialog';
import { DialogComponent } from '@comparit/core';

@Component({
  selector: 'app-mlp-import-hint-dialog',
  templateUrl: './mlp-import-hint-dialog.component.html',
  styleUrl: './mlp-import-hint-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DialogComponent, MatButtonModule],
})
export class MlpImportHintDialogComponent {
  private readonly dialogRef = inject(MatDialogRef);

  protected close(): void {
    this.dialogRef.close();
  }
}
